import { render, staticRenderFns } from "./autoRetouch.vue?vue&type=template&id=6273a032&scoped=true&"
import script from "./autoRetouch.vue?vue&type=script&lang=js&"
export * from "./autoRetouch.vue?vue&type=script&lang=js&"
import style0 from "./autoRetouch.vue?vue&type=style&index=0&id=6273a032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273a032",
  null
  
)

export default component.exports